import React from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WithTranslation, withTranslation } from "react-i18next";

interface SaveAndPublishButtonProps extends WithTranslation {
  className?: string;
  onClick?: () => void;
}

const SaveAndPublishButton: React.FC<SaveAndPublishButtonProps> = ({ t, className = '', onClick }) => {
  return (
    <Button 
      variant="outline-success" 
      type="submit" 
      className={`greenInput font-weight-bold ${className}`}
      onClick={onClick}
    >
      <FontAwesomeIcon className="mr-2" icon={["fal", "cloud-arrow-up"]}/>
      {t("manageVenuesScreen.saveAndPublish")}
    </Button>
  );
};

export default withTranslation()(SaveAndPublishButton); 